import { useContext } from 'react'
import { matchPath, Navigate, Outlet, useLocation } from 'react-router-dom'

import { AppRoutes } from '../../models'
import { AuthContext } from '../../providers'
import { sendBugReport } from '../../utils/handleError/sendBugReport'

export default function RequireAuth() {
  const { currentUser } = useContext(AuthContext)
  const location = useLocation()

  if (!currentUser) {
    if (location.pathname !== '/') {
      // Setting this bug report here to troubleshoot a potential race condition
      // causing users to get redirected to the login page even if they still
      // have a valid token in local storage.
      // Due to the long token expiration time in production, this bug report
      // should happen relatively infrequently.
      // The base URL '/' is expected to be accessed fairly frequently and thus
      // is ignored for this alert.
      sendBugReport(
        'warning',
        'RequireAuth login redirect',
        'The RequireAuth component has detected that a user has tried to ' +
          'access a route that requires a login, but the user is not logged in. ' +
          'Therefore, the RequireAuth component will redirect the user to either ' +
          'DVI or main app login page.\n' +
          'Note that redirects from the base URL "/" are not alerted.' +
          `URL before redirect: ${location.pathname}`
      )
    }
    if (matchPath(`${AppRoutes.DVI_HOME}/*`, location.pathname)) {
      return <Navigate to={AppRoutes.DVI_LOGIN} state={{ from: location }} />
    }
    return <Navigate to={AppRoutes.LOGIN} state={{ from: location }} />
  }
  window.addEventListener('storage', (e) => {
    if (e.key === 'InTuneCurrentUserAccessToken' && e.newValue === null) {
      window.location.reload()
    }
  })
  return <Outlet />
}
